import { type RemoteActionsResponse } from '../../common/types';

const RETRY_HTTP_CODES = [408, 500, 502, 503, 504, 522, 524];

function timeout(ms: number) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

async function fetchRetry(
	url: string,
	options = {},
	retries = 5,
	backoff = 300,
): Promise<globalThis.Response | undefined> {
	const response = await fetch(url, options);
	if (response.ok || response.status === 401) {
		return response;
	}

	if (retries > 1 && RETRY_HTTP_CODES.includes(response.status)) {
		await timeout(backoff);
		return await fetchRetry(url, options, retries - 1, backoff * 2);
	} else {
		throw new Error(`Failed to fetch remote actions with status ${response.status}`);
	}
}

const getRemoteActionsUrlForProduct = (endpoint: string, product: string) =>
	`${endpoint}/${product}.json`;

export const getRemoteActions = async (
	endpoint: string,
	product: string,
): Promise<RemoteActionsResponse | void> => {
	const remoteActionsUrl = getRemoteActionsUrlForProduct(endpoint, product);
	const response = await fetchRetry(remoteActionsUrl, {
		cache: 'no-store',
		method: 'GET',
	});

	if (response && response.ok) {
		const remoteActionsResponse = await response.json();
		if (
			remoteActionsResponse &&
			typeof remoteActionsResponse.lastUpdatedAt === 'number' &&
			remoteActionsResponse.remoteActions instanceof Array
		) {
			return remoteActionsResponse as RemoteActionsResponse;
		}
	}
};
